import { render, staticRenderFns } from "./OneNotification.vue?vue&type=template&id=2d91b37d&scoped=true&"
import script from "./OneNotification.vue?vue&type=script&lang=js&"
export * from "./OneNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91b37d",
  null
  
)

export default component.exports